'use client';

import { c as _c } from "react/compiler-runtime";
import { ClerkProvider } from '@clerk/nextjs';
import { dark } from '@clerk/themes';
import { useTheme } from 'next-themes';
import { usePathname } from 'next/navigation';
import { ClerkAuthStoreProvider } from '@/stores/ClerkAuthStore';
import { UserStoreProvider } from '@/stores/UserStore';
import dynamicImport from 'next/dynamic';
import { ToastContainer } from 'react-toastify';
import { DevBanner } from '@/components/DevBanner';
import InstallAppPrompt from '@/components/InstallAppPrompt';
import { usePartnerSlug } from '@/hooks/usePartner';
const RudderIdentifyAndTrackPageViews = dynamicImport(() => import('../components/RudderIdentifyAndTrackPageViews'), {
  ssr: false
});
const IntercomMessengerWithNoSSR = dynamicImport(() => import('../components/IntercomMessenger'), {
  ssr: false
});
const AnalyticsProviderWithNoSSR = dynamicImport(() => import('../components/analytics/AnalyticsProvider'), {
  ssr: false
});
export const MainLayout = t0 => {
  const $ = _c(22);
  const {
    children
  } = t0;
  const {
    theme
  } = useTheme();
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname?.startsWith("/record/") ?? false;
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hideIntercom = t1;
  const afterSignUpUrl = usePartnerSlug() ? "/boards" : "/onboarding/questions";
  if (pathname?.startsWith("/social-upload/")) {
    let t2;
    if ($[2] !== children) {
      t2 = <>{children}</>;
      $[2] = children;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      colorPrimary: "rgba(80, 70, 229,1)"
    };
    t3 = {
      logoImageUrl: "/logo-no-text.png",
      unsafe_disableDevelopmentModeWarnings: true
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = theme === "dark" ? dark : undefined;
  let t5;
  if ($[6] !== t4) {
    t5 = {
      variables: t2,
      layout: t3,
      theme: t4
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      signUp: {
        start: {
          subtitle: "Please sign up with your Poppy AI purchase email to get started!"
        }
      }
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AnalyticsProviderWithNoSSR />;
    t8 = <RudderIdentifyAndTrackPageViews />;
    t9 = <DevBanner />;
    t10 = <ToastContainer />;
    $[9] = t10;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[13] !== hideIntercom) {
    t11 = !hideIntercom && <IntercomMessengerWithNoSSR />;
    $[13] = hideIntercom;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== children || $[16] !== t11) {
    t12 = <ClerkAuthStoreProvider><UserStoreProvider>{t7}{t8}{t9}{t10}{t11}{children}</UserStoreProvider></ClerkAuthStoreProvider>;
    $[15] = children;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== afterSignUpUrl || $[19] !== t12 || $[20] !== t5) {
    t13 = <ClerkProvider signInUrl="/login" signUpUrl="/signup" afterSignOutUrl="/login" signUpFallbackRedirectUrl={afterSignUpUrl} signUpForceRedirectUrl={afterSignUpUrl} appearance={t5} localization={t6}>{t12}</ClerkProvider>;
    $[18] = afterSignUpUrl;
    $[19] = t12;
    $[20] = t5;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
};